/**
 * Types d'événements SAV V2
 * Correspond exactement aux types backend
 */
export enum SavV2EventType {
  DECLARED = 'DECLARED',
  REPAIRER_ASSIGNED = 'REPAIRER_ASSIGNED',
  REPAIRER_UNASSIGNED = 'REPAIRER_UNASSIGNED',
  REPAIRER_CONTACTED = 'REPAIRER_CONTACTED',
  REPAIRER_CREATED_FROM_GOOGLE_PLACE = 'REPAIRER_CREATED_FROM_GOOGLE_PLACE',
  QUOTE_UPLOADED = 'QUOTE_UPLOADED',
  QUOTE_SELECTED_FOR_ANALYSIS = 'QUOTE_SELECTED_FOR_ANALYSIS',
  ANALYSIS_COMPLETED = 'ANALYSIS_COMPLETED',
  QUOTE_INVALIDATED = 'QUOTE_INVALIDATED',
  INTERVENTION_CREATED = 'INTERVENTION_CREATED',
  INTERVENTION_CLOSED = 'INTERVENTION_CLOSED',
  INTERVENTION_REOPENED = 'INTERVENTION_REOPENED',
  DECISION_CREATED = 'DECISION_CREATED',
  DECISION_UPDATED = 'DECISION_UPDATED',
  DECISION_DELETED = 'DECISION_DELETED',
  DECISION_SENT_TO_GARANT = 'DECISION_SENT_TO_GARANT',
  DECISION_REMINDER_SENT = 'DECISION_REMINDER_SENT',
  GARANT_VALIDATION_LINK_RENEWED = 'GARANT_VALIDATION_LINK_RENEWED',
  DECISION_VALIDATED = 'DECISION_VALIDATED',
  DECISION_REFUSED = 'DECISION_REFUSED',
  DECISION_CANCELLED = 'DECISION_CANCELLED',
  DECISION_SIGNED_BY_MANDATE = 'DECISION_SIGNED_BY_MANDATE',
  DECISION_VALIDATION_RESET = 'DECISION_VALIDATION_RESET',
  COVERAGE_DECISION_CREATED = 'COVERAGE_DECISION_CREATED',
  SIGNATURE_CANCELLED = 'SIGNATURE_CANCELLED',
  MESSAGE_INTERNAL = 'MESSAGE_INTERNAL',
  MESSAGE_TO_BENEFICIARY = 'MESSAGE_TO_BENEFICIARY',
  MESSAGE_FROM_BENEFICIARY = 'MESSAGE_FROM_BENEFICIARY',
  MESSAGE_TO_GARANT = 'MESSAGE_TO_GARANT',
  MESSAGE_FROM_GARANT = 'MESSAGE_FROM_GARANT',
  MESSAGE_BENEF_PROCESSED = 'MESSAGE_BENEF_PROCESSED',
  MESSAGE_GARANT_PROCESSED = 'MESSAGE_GARANT_PROCESSED',
  MESSAGE_INTERNAL_PROCESSED = 'MESSAGE_INTERNAL_PROCESSED',
  DOCUMENT_ADDED = 'DOCUMENT_ADDED',
  DOCUMENT_ADDED_INTERNAL = 'DOCUMENT_ADDED_INTERNAL',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  SANS_SUITE = 'SANS_SUITE',
  PENDING_ACTION_SET = 'PENDING_ACTION_SET',
  PENDING_ACTION_COMPLETED = 'PENDING_ACTION_COMPLETED',
  PENDING_ACTION_CANCELLED = 'PENDING_ACTION_CANCELLED',
  LEGAL_BLOCKED = 'LEGAL_BLOCKED',
  LEGAL_UNBLOCKED = 'LEGAL_UNBLOCKED',
  MANAGER_ASSIGNED = 'MANAGER_ASSIGNED',
  MANAGER_CHANGED = 'MANAGER_CHANGED',
  SATISFACTION_SURVEY_SENT = 'SATISFACTION_SURVEY_SENT',
  SATISFACTION_SURVEY_RATED = 'SATISFACTION_SURVEY_RATED',
  SATISFACTION_SURVEY_SUBMITTED = 'SATISFACTION_SURVEY_SUBMITTED',
  BENEFICIARY_EMAIL_UPDATED = 'BENEFICIARY_EMAIL_UPDATED',
  AWAITING_FLAGS_UPDATED = 'AWAITING_FLAGS_UPDATED',

  // Cycle paiement réparateur (cf. api docs/repairer-payment-cycle.md)
  REPAIRER_INVOICE_CREATED = 'REPAIRER_INVOICE_CREATED',
  REPAIRER_INVOICE_ARMED = 'REPAIRER_INVOICE_ARMED',
  REPAIRER_INVOICE_UPLOADED = 'REPAIRER_INVOICE_UPLOADED',
  REPAIRER_INVOICE_DISPUTED = 'REPAIRER_INVOICE_DISPUTED',
  REPAIRER_INVOICE_VALIDATED = 'REPAIRER_INVOICE_VALIDATED',
  REPAIRER_INVOICE_SENT_TO_GARANT = 'REPAIRER_INVOICE_SENT_TO_GARANT',
  REPAIRER_INVOICE_CANCELLED = 'REPAIRER_INVOICE_CANCELLED',
  GARANT_DECLARED_PAID = 'GARANT_DECLARED_PAID',
  REPAIRER_CONFIRMED_PAYMENT = 'REPAIRER_CONFIRMED_PAYMENT',
  REPAIRER_CONFIRMED_PAYMENT_AFTER_DISPUTE = 'REPAIRER_CONFIRMED_PAYMENT_AFTER_DISPUTE',
  REPAIRER_DISPUTED_PAYMENT = 'REPAIRER_DISPUTED_PAYMENT',
  PAYMENT_ESCALATED_TO_AFFINICAR = 'PAYMENT_ESCALATED_TO_AFFINICAR',
  INTERVENTION_FULLY_COMPLETED = 'INTERVENTION_FULLY_COMPLETED',
  COMPANY_RIB_UPDATED_FROM_INVOICE = 'COMPANY_RIB_UPDATED_FROM_INVOICE',
  REPAIRER_INVOICE_OTP_SENT = 'REPAIRER_INVOICE_OTP_SENT',
  REPAIRER_INVOICE_OTP_VALIDATED = 'REPAIRER_INVOICE_OTP_VALIDATED',
}

/**
 * Métadonnées d'un événement (varie selon le type)
 */
export interface EventMetadata {
  // Pour REPAIRER_ASSIGNED / REPAIRER_UNASSIGNED / REPAIRER_CONTACTED
  interventionId?: string;
  repairerUuid?: string;
  repairerName?: string;
  assignedBy?: string;
  unassignedBy?: string;
  previousRepairerUuid?: string;
  previousRepairerName?: string;
  
  // Pour REPAIRER_CONTACTED
  contactedAt?: string;
  contactedBy?: string;
  notes?: string;
  outcome?: 'available' | 'unavailable' | 'no_answer' | 'pending';
  
  // Pour QUOTE_UPLOADED et DOCUMENT_ADDED
  documentId?: number;
  fileName?: string;
  fileSize?: number;
  documentType?: string;
  
  // Pour QUOTE_SELECTED_FOR_ANALYSIS
  quoteId?: string;
  
  // Pour ANALYSIS_COMPLETED
  decision?: 'approved' | 'partial' | 'rejected';
  
  // Pour QUOTE_INVALIDATED et REPAIRER_UNASSIGNED
  reason?: string;
  
  // Pour CANCELLED
  cancelReason?: string;
  
  // Pour DECISION_* events
  amount?: number | string;
  decisionType?: string;
  garantName?: string;
  validatedBy?: string;
  refusalReason?: string;
  
  // Pour MESSAGE_* events
  messageId?: number;
  hasAttachments?: boolean;
  subject?: string;
  messagePreview?: string;
  messageChannel?: string;

  // Pour MANAGER_ASSIGNED / MANAGER_CHANGED
  managerUuid?: string;
  managerName?: string;
  previousManagerUuid?: string;
  previousManagerName?: string;

  // Pour BENEFICIARY_EMAIL_UPDATED
  oldEmail?: string;
  newEmail?: string;
  beneficiaryId?: number;

  // Données génériques
  description?: string;
  [key: string]: any;
}

/**
 * Événement SAV V2
 */
export interface SavV2Event {
  id: number;
  savId?: number;
  eventType: SavV2EventType;
  metadata?: EventMetadata | null;
  createdAt: string;
  createdBy?: string;
  createdByName?: string; // Nouveau champ avec le nom réel du créateur
}